import React, {Component, Fragment} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Application from '../components/CASAForm/Application';
import {addPageAlert, clearPageAlert} from '../PortalStore/Actions/PageAlertActions';
import queryString from 'query-string';

import {SUBMISSION_SUCCESS} from '../FormStore/Actions/FormServiceActions/GenericFormServiceActions/SubmissionAction';
import { getB2cSettingsSelector } from '../PortalStore/Selectors/SystemSettingSelectors';
import {submitMplForm} from '../FormStore/Actions/FormServiceActions/MplFormServices/MplSubmissionAction';
import {
    FETCH_ESB_REFERENCE_DATA_SUCCESS,
    fetchEsbReferenceData
} from '../FormStore/Actions/FormServiceActions/MplFormServices/GetEsbReferenceDataAction';
import {
    clearFormData,
    clearSpecificFormData,
    loadMplFormData,
    removeStudent
} from '../FormStore/Actions/FormDataActions/MPL/AddMPLFormData';
import {getFormDataSelector, getFormPropertiesSelector} from '../FormStore/Selectors/FormDataSelectors';
import MPLAddStudent from './CustomSteps/MPL/MPLAddStudent';
import MPLNotificationTypeSelection from './CustomSteps/MPL/MPLNotificationTypeSelection';
import MPLAddCourseCode from './CustomSteps/MPL/MPLAddCourseCode';
import MPLRemovalTypeSelection from './CustomSteps/MPL/MPLRemovalTypeSelection';
import MPLStudentSummary from './CustomSteps/MPL/MPLStudentSummary';
import {
    FETCH_MTO_DETAILS_SUCCESS,
    getMtoCertificateDetails
} from "../FormStore/Actions/FormServiceActions/GenericFormServiceActions/GetMtoCertificateDetailsAction";
import PropTypes from "prop-types";
import CasaModal from '../components/CASA/CasaModal';
import CasaSpinner from '../components/Portal/CASASpinner';
import SuccessScreen from "../pages/SuccessScreen";

class MTONotificationOfTraining extends Component {
    constructor(props) {
        super(props);

        const urlParameters = this.processUrlParameters(window.location.search);

        this.state = {
            formLoaded: false,
            formLoadError: false,
            currentStep: "notificationType",
            stepProperties: {},
            modalActive: false,
            applicationSubmitting: false,
            submissionSucceeded: false,
            removeStudent: {
                modalActive: false
            },
            organisationArn: urlParameters.organisationArn ?? null,
            recordId: urlParameters.recordid ?? null,
            link: urlParameters.breadcrumbs[0].link
        }
    }

    componentDidMount() {
        this.props.dispatch(addPageAlert({level: '', title: ''}));

        if (!this.state.formLoaded) {
            this.getMtoCertificateDetails();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.formProperties.submitForm &&
            prevProps.formProperties.submitForm !== this.props.formProperties.submitForm) {
                this.submitMtoNotificationForm()
        }
    }

    //get from utils
    processUrlParameters = (windowUrl) => {
        let urlParameters = queryString.parse(windowUrl)
        if (urlParameters !== undefined) {
            return JSON.parse(atob(decodeURIComponent(urlParameters.params)))
        }
    }

    getMtoCertificateDetails = () => {
        const webappurlForms = this.props.b2cSettings.webappurlFormsApi;
            axios.all([
                this.props.dispatch(getMtoCertificateDetails(webappurlForms, this.props.b2cSettings.accesstokenForms, this.state.organisationArn)),
                this.props.dispatch(fetchEsbReferenceData(webappurlForms, this.props.b2cSettings.accesstokenForms, 'MPL Limitations'))
            ]).then(axios.spread((mtoCertificate, referenceData) => {
                if (mtoCertificate.type === FETCH_MTO_DETAILS_SUCCESS
                    && referenceData.type === FETCH_ESB_REFERENCE_DATA_SUCCESS) {
                    //TODO change the object from trainings to trainingCourses after the integrations
                    this.setState({
                        //trainingCourses: mtoCertificate.payload.certificateDetails.trainings,
                        formLoaded: true
                    });
                } else {
                    this.setState({
                        trainingCourses: [],
                        formLoadError: true,
                        formLoaded: true
                    });
                    this.props.dispatch(addPageAlert({
                        level: "error",
                        title: "Unable to complete application online",
                        message: "Unfortunately this application cannot be completed online. Please contact us for further information."
                    }));
                }
            }))
    }

    loadMplDraftForm = (formData) => {
        this.props.dispatch(loadMplFormData(formData));

        if (formData?.students) {
            if (Object.values(formData.students).length > 0) {
                this.setState({currentStep: "summary"})
            }
        }
    }

    getDraftCurrentStep = () => {
        let currentStep = "notificationType";

        if (Object.keys(this.props.formData?.students).length) {
            currentStep = "summary";
        } else if (this.props.formData?.courseCode) {
            currentStep = "courseCode";
        } else if (this.props.formData?.removalType) {
            currentStep = "removalType";
        }

        return currentStep;
    }

    notificationTypeReturn = (result) => {
        if (result === 'notificationTrainingOutcome') {
            this.setState({
                currentStep: 'courseCode',
                stepProperties: {
                    title: "<abbr title='Maintenance training organisation'>MTO</abbr> Notification of training outcomes for category or type",
                    subheading: ""
                }
            })
        } else {
            this.setState({
                currentStep: 'removalType',
                stepProperties: {
                    title: "Removal of exclusion from an existing category or type",
                    subheading: ""
                }
            })
        }
    }

    loadAddStudent = (selectedCourse) => {
        this.setState({
            currentStep: 'addStudent',
            stepProperties: {
                courseCode: selectedCourse.courseCode,
                courseDescription: selectedCourse.courseDescription,
                courseOutcome: selectedCourse.courseOutcome,
                removalType: this.props.formData.removalType
            }
        })
    }

    removalTypeReturn = (result) => {
        if (result.value === 'type') {
            this.setState({
                currentStep: 'courseCode',
                stepProperties: {
                    title: "Type removal details",
                    subheading: ""
                }
            })
        } else {
            this.setState({
                currentStep: 'addStudent',
                stepProperties: {
                    isRemovalCategory: true,
                    removalType: result
                }
            })
        }
    }

    loadSummary = () => {
        this.setState({
            currentStep: 'summary'
        })
    }

    editUserDetails = (studentArn, e) => {
        e.preventDefault();
        const exisitingStudent = this.props.formData.students[studentArn]

        this.setState({
            currentStep: 'addStudent',
            stepProperties: {
                courseCode: this.props.formData.courseCode,
                courseDescription: this.props.formData.courseDescription,
                courseOutcome: this.props.formData.courseOutcome,
                removalType: this.props.formData.removalType,
                student: exisitingStudent
            }
        })
    }

    removeUserDetails = (e) => {
        e.preventDefault();
        this.props.dispatch(removeStudent(this.state.removeStudent?.arn));
        this.setState({
            ...this.state,
            modalActive: false,
            removeStudent: {
                modalActive: false
            }
        })
        this.props.dispatch(clearPageAlert());
    }

    returnFromCourseCode = () => {
        let currentStep = 'notificationType';
        let stepProperties = {notificationType: this.props.formData.notificationType};

        if (this.props.formData.notificationType.value === 'removalOfExclusion') {
            currentStep = 'removalType';
            stepProperties = {removalType: this.props.formData.removalType};
        }

        this.setState({
            currentStep: currentStep,
            stepProperties: stepProperties
        })
    }

    returnFromRemovalTypeSelection = () => {
        this.setState({
            currentStep: 'notificationType',
            stepProperties: {notificationType: this.props.formData.notificationType}
        })
        this.props.dispatch(clearSpecificFormData(["removalType"]));
    }

    returnFromAddStudent = () => {
        let currentStep = 'courseCode';
        let stepProperties = {
            courseCode: this.props.formData.courseCode,
            courseOutcome: this.props.formData.courseOutcome,
            courseDescription: this.props.formData.courseDescription
        };

        if (Object.values(this.props.formData.students).length) {
            currentStep = 'summary';
        } else if (this.props.formData.removalType?.value === 'category') {
            currentStep = 'removalType';
            stepProperties = {removalType: this.props.formData.removalType};
        }

        this.setState({
            currentStep: currentStep,
            stepProperties: stepProperties
        })
    }

    clearFormOnPrevious = () => {
        this.props.dispatch(clearFormData());
        this.props.dispatch(clearPageAlert());
        this.setState({
            modalActive: false,
            removeStudent: {
                modalActive: false
            },
            currentStep: 'notificationType',
            stepProperties: {}
        })
    }

    toggleModal = () => {
        this.setState({
            modalActive: !this.state.modalActive
        })
    };

    submitMtoNotificationForm = () => {
        this.setState({applicationSubmitting: true})
        const webappurlForms = this.props.b2cSettings.webappurlFormsApi;

        this.props.dispatch(submitMplForm(webappurlForms, this.props.b2cSettings.accesstokenForms, this.props.formProperties, this.props.formData))
            .then(response => {
                if (response.type === SUBMISSION_SUCCESS) {
                    this.setState({
                        ...this.state,
                        applicationSubmitting: false,
                        submissionSucceeded: true,
                        currentStep: ""
                    });
                    this.props.dispatch(addPageAlert({
                        level: 'success',
                        title: 'Notification submitted successfully'
                    }));
                } else {
                    this.setState({applicationSubmitting: false})
                    this.props.dispatch(addPageAlert({
                        level: "error",
                        title: "Unable to complete application online",
                        message: 'Unfortunately this application cannot be completed online. Please contact us for further information.'
                    }));
                }
            })
    }

    toggleRemoveStudentModal = (e, studentArn, studentname) => {
        e.preventDefault();
        this.setState({
            removeStudent: {
                modalActive: !this.state.removeStudent.modalActive,
                arn: studentArn,
                name: studentname
            }
        })
    };

    enableSaveButton = () => {
        let enableShowButton = false;

        // Save button should only display on Summary step
        if (this.state.currentStep === "summary") {
            enableShowButton = true;

            // Unless files have been uploaded against a student
            let studentsAdded = this.props.formData?.students;
            Object.keys(studentsAdded).map(function (keyName) {
                if (studentsAdded[keyName].additionalDetails?.recognitionOfPriorLearning?.answer.value === "Yes") {
                    enableShowButton = false;
                }
            })
        }

        return enableShowButton;
    }

    renderStep = () => {
        switch (this.state.currentStep) {
            case 'notificationType':
                return (
                    <MPLNotificationTypeSelection
                        properties={this.state.stepProperties}
                        onNextClick={this.notificationTypeReturn}
                        backurl={this.state.link}
                    />
                )
            case 'courseCode':
                return (
                    <MPLAddCourseCode
                        properties={this.state.stepProperties}
                        onNextClick={this.loadAddStudent}
                        onPreviousClick={this.returnFromCourseCode}
                    />
                )
            case 'addStudent':
                return (
                    <MPLAddStudent
                        properties={this.state.stepProperties}
                        onNextClick={this.loadSummary}
                        onPreviousClick={this.returnFromAddStudent}
                        clearForm={this.toggleModal}
                    />
                )
            case 'removalType':
                return (
                    <MPLRemovalTypeSelection
                        properties={this.state.stepProperties}
                        onNextClick={this.removalTypeReturn}
                        onPreviousClick={this.returnFromRemovalTypeSelection}
                    />
                )
            case 'summary':
                return (
                    <MPLStudentSummary
                        editUserCallback={this.editUserDetails}
                        addAdditionalStudent={this.loadAddStudent}
                        removeUserCallback={this.toggleRemoveStudentModal}
                        onPreviousClick={this.toggleModal}
                        submitForm={this.submitMtoNotificationForm}/>
                )
            default:
                return ''
        }
    }

    render() {
        if (this.state.submissionSucceeded) {
            return (
                <SuccessScreen>
                    <div>
                        <p>Thank you,</p>
                        <p>Your notification of training outcome has been submitted successfully.</p>
                        <p>Students listed on this notification have been notified by email.</p>
                        <p>A copy of your notification details has been sent to your email
                            address <strong>{this.props.userdetails.items.value[0].emailaddress1}</strong></p>
                    </div>
                </SuccessScreen>
            )
        }
        return (
            <Fragment>
                <CasaModal
                    heading="Remove student"
                    toggle={this.toggleRemoveStudentModal}
                    active={this.state.removeStudent.modalActive}
                    actionLabel="Yes"
                    action={this.removeUserDetails}>
                    <div>
                        <p>Are you sure you want to remove this student from the notification?</p>
                        <p>
                            <strong>Name</strong><br/>
                            {this.state.removeStudent?.name}
                        </p>
                        <p><strong>ARN</strong><br/> {this.state.removeStudent?.arn}</p>
                    </div>

                </CasaModal>
                {this.state.applicationSubmitting && <CasaSpinner message='Submitting form'/>}
                {!this.state.formLoaded && <CasaSpinner/>}
                {this.state.formLoaded &&
                <Application
                    formInformation={{
                        id: "notificationOfTrainingOutcomes",
                        name: "MTO Notification of training outcomes",
                        title: "<abbr title=\"Maintenance training organisation\">MTO</abbr> Notification of training outcomes",
                        rootFormCode: "MPL",
                        formCode: "MPL_NOTIFICATION",
                        version: "01",
                        formDataType: "mplFormData"
                    }}
                    formActions={{
                        submit: this.submitForm,
                        loadDraft: this.loadMplDraftForm
                    }}
                    validate={this.validateForm}
                    showback={false}
                    enableForm={!this.state.formLoadError}
                    enableSaveButton={this.enableSaveButton()} >

                    {this.renderStep(this.state.currentStep)}
                </Application>}
            </Fragment>
        );
    }
}

MTONotificationOfTraining.propTypes = {
    userdetails: PropTypes.object,
    formData: PropTypes.object,
    formProperties: PropTypes.object,
    dispatch: PropTypes.func,
    b2cSettings: PropTypes.object,
    ClientApp: PropTypes.object,
    link: PropTypes.string
}

const mapStateToProps = (state) => {
    return {
        userdetails: state.userdetails,
        pageAlert: state.pageAlert,
        ClientApp: state.ClientApp,
        formData: getFormDataSelector(state.formStore, 'mplFormData'),
        formProperties: getFormPropertiesSelector(state.formStore),
        b2cSettings: getB2cSettingsSelector(state.B2CSettings, ['webappurlFormsApi', 'accesstokenForms', 'parsed'])
    }
}

export default connect(mapStateToProps)(MTONotificationOfTraining);